export const routes = [
  { id: 1, path: '/', name: 'home', aria: 'Home page' },
  { id: 2, path: '/catalog', name: 'catalog', aria: 'catalog page' },
  { id: 3, path: '/library', name: 'my library', aria: 'my library page' },
];
